import { useEffect, useState } from "react";
import "./ProjectsDashboard.css";
import Loader from "../../Loader";
import NoteCard from "./NoteCard";
import { Container } from "@mui/system";
import { Grid } from "@mui/material";
export default function ProjectsDashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState({
    name: "",
    project_image: "",
    description: "",
    live: "",
  });
  useEffect(() => {
    async function getData() {
      const response = await fetch(`${process.env.REACT_APP_server}/projects`);
      let projects = await response.json();
      setProjects(projects);
      setIsLoading(false);
    }
    getData();
  }, [projects]);

  const handleDelete = async (id) => {
    await fetch(`${process.env.REACT_APP_server}/projects/${id}`, {
      method: "DELETE",
    });
  };

  const handleEdit = async (id) => {
    await fetch(`${process.env.REACT_APP_server}/projects/${id} + body.id`, {
      method: "PUT",
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="projects_dashboard">
          <Container>
            <Grid container spacing={3}>
              {projects.map((projects) => (
                <Grid item key={projects._id} xs={12} md={6} lg={4}>
                  <NoteCard
                    projects={projects}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    id={projects._id}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
        </div>
      )}
    </>
  );
}
